import Link from 'next/link'
import classNames from 'classnames/bind'
import moment from 'moment'
import Moment from 'react-moment'

import { withI18next } from '../../../lib/withI18next'

const SubscriptionItem = props => {
  const inactive = !props.dateTo
  const expired = !inactive && !(props.dateTo && moment(props.dateTo).isAfter(moment().utc()))
  return (
    <div id={props.id} className="subscriptions-item m-b-md p-b-md">
      <div className="subscriptions-title is-size-6">
        {props.title}
      </div>
      <div className="subscriptions-body">
        <div
          className={classNames({
            'subscriptions-date': true,
            'has-text-danger': expired || inactive
          })}
        >
          {
            inactive && <span>{props.t('inactive')}</span>
          }
          {
            expired ? (
              <span>{props.t('expired')}</span>
            ) : (
              !inactive &&
              <div className="has-text-success">
                {props.t('expires-on')}: <Moment format="MM/DD/YYYY">{props.dateTo}</Moment>
              </div>
            )
          }
        </div>
        {
          (expired || inactive) &&
          <div className="subscriptions-subscribe">
            <Link href={props.linkTo}>
              <a>{props.t('subscribe')}</a>
            </Link>
          </div>
        }
      </div>
    </div>
  )
}

export default withI18next('common')(SubscriptionItem)



// WEBPACK FOOTER //
// ./components/Common/UserDetails/SubscriptionItem.js